// proceduralLibrary/presets/manifest.js
//
// Manifest for the AI-generated preset wallpaper images (WP-IMG). 12 deck-named
// scenes x 2 takes = 24 presets. Full images (1216x832 webp, ~98KB) live at
// /wallpaper-presets/webp/<file>; 240px thumbnails (~4.5KB) at
// /wallpaper-presets/thumbs/<file>. The picker grid shows THUMBS and applies the
// full webp via the existing image-wallpaper path (currentBg === 2).
//
// Assets copied into public/ from
// specs/media-libraries/assets/wallpaper-presets/ (see raw/manifest.json).

import { toAbsoluteUrl } from "../../../utils/absoluteUrl";

const PUBLIC_BASE = process.env.PUBLIC_URL || "";
export const WEBP_DIR = `${PUBLIC_BASE}/wallpaper-presets/webp`;
export const THUMB_DIR = `${PUBLIC_BASE}/wallpaper-presets/thumbs`;

// [scene-slug, display label] — deck's 12 named scenes.
const SCENES = [
  ["alpine-sunrise", "Alpine sunrise"],
  ["ocean-swell", "Ocean swell"],
  ["forest-mist", "Forest mist"],
  ["city-dusk", "City dusk"],
  ["cherry-blossom", "Cherry blossom"],
  ["lavender-fields", "Lavender fields"],
  ["balloon-morning", "Balloon morning"],
  ["autumn-path", "Autumn path"],
  ["tropical-shore", "Tropical shore"],
  ["rainy-window", "Rainy window"],
  ["winter-pines", "Winter pines"],
  ["golden-meadow", "Golden meadow"],
];

// 24 presets: two takes per scene (t1, t2).
export const PRESETS = SCENES.flatMap(([slug, label]) =>
  [1, 2].map((take) => {
    const file = `${slug}-t${take}.webp`;
    return {
      id: `${slug}-t${take}`,
      scene: slug,
      take,
      label: take === 1 ? label : `${label} II`,
      thumb: `${THUMB_DIR}/${file}`,
      // `full` is the value APPLIED + PERSISTED (wallpaper_settings.bg_wallpaper
      // and POST /wheel/wheel-media/write/). The backend `urls` field is a
      // Django URLField requiring an ABSOLUTE URL, so a relative preset path is
      // rejected 400 "Enter a valid URL" (uploads pass because their S3 URLs are
      // absolute). Absolutize here so preset persistence matches the upload
      // contract. thumb stays relative — it is only ever an <img> src.
      full: toAbsoluteUrl(`${WEBP_DIR}/${file}`),
    };
  })
);

export const PRESET_BY_ID = PRESETS.reduce((acc, p) => {
  acc[p.id] = p;
  return acc;
}, {});
